import React from 'react';
import { ConfirmationPopup } from './ConfirmationPopup';
import { AlertPopup } from './AlertPopup';
export function PopupRenderer(param) {
    var isOpen = param.isOpen, componentName = param.componentName, componentProps = param.componentProps;
    if (isOpen) {
        switch(componentName){
            case 'ConfirmationPopup':
                return /*#__PURE__*/ React.createElement(ConfirmationPopup, componentProps);
            case 'AlertPopup':
                return /*#__PURE__*/ React.createElement(AlertPopup, componentProps);
            default:
                return null;
        }
    }
    return null;
}
